import api from '@/api'

export default {
  namespaced: true,
  state: {
    products: [],
    viewedProductsInfo: {},
    isLoading: false
  },
  getters: {
    viewedProductsQuantity ({ viewedProductsInfo }) {
      if (!viewedProductsInfo) return null

      return viewedProductsInfo.goods_all ? viewedProductsInfo.goods_all : null
    },
    productsIdsInViewedProducts ({ viewedProductsInfo }) {
      if (!viewedProductsInfo) return []

      return viewedProductsInfo.products_ids ? viewedProductsInfo.products_ids : []
    },
    productsForRender ({ products }, { productsIdsInViewedProducts }) {
      if (!products) return []

      return products.filter(x => productsIdsInViewedProducts.includes(x.id))
    }
  },
  mutations: {
    SET_VIEWED_PRODUCTS_INFO (state, info) {
      state.products = [...state.products, ...info.products]
      state.viewedProductsInfo = info
    },
    SET_SHORT_VIEWED_PRODUCTS_INFO (state, info) {
      state.viewedProductsInfo = { ...state.viewedProductsInfo, ...info }
    },
    SET_IS_LOADING (state, bool) {
      state.isLoading = bool
    },
    RESET_VIEWED_PRODUCTS_INFO (state) {
      state.products = []
      state.viewedProductsInfo.offset = 0
    }
  },
  actions: {
    GET_VIEWED_PRODUCTS_INFO ({ commit, state }) {
      const params = {}

      if (state.viewedProductsInfo?.offset) params.offset = state.viewedProductsInfo.offset

      commit('SET_IS_LOADING', true)

      api.cabinet.getViewedProducts(params)
        .then(res => {
          if (res.status === 'success') {
            commit('SET_VIEWED_PRODUCTS_INFO', res)
          }
        })
        // .catch(err => {
        //   console.log(err)
        // })
        .finally(() => {
          commit('SET_IS_LOADING', false)
        })
    },
    SET_SHORT_VIEWED_PRODUCTS_INFO_ACTION ({ commit }, info) {
      commit('SET_SHORT_VIEWED_PRODUCTS_INFO', info)
    },
    RESET_VIEWED_PRODUCTS_INFO_ACTION ({ commit }) {
      commit('RESET_VIEWED_PRODUCTS_INFO')
    }
  }
}
